// assets/svd-lp-offer-one.js
// Skapad av Claude Code 2026-08-18 — visar/döljer engångs-stacken ([data-svd-lpo])
// utifrån vald variant i sektionens köpblock. Kvalificerande variant-ID:n ligger i
// data-main-ids (stackens varianter-poster). Startar hidden i markupen — utan JS
// visas inget gåvolöfte alls (hellre inget löfte än ett falskt).
(function () {
  'use strict';

  function initBox(box) {
    if (box.dataset.lpoInit) return;
    box.dataset.lpoInit = '1';
    // Inline-instanser (i köpraderna, offer_stack_inline) syns/döljs helt via CSS
    // på .is-selected — hidden-togglingen här skulle annars visa BÅDA radernas
    // stackar så fort en kvalificerande rad är vald.
    if (box.hasAttribute('data-lpo-inline')) return;
    var main = [];
    try { main = JSON.parse(box.getAttribute('data-main-ids') || '[]'); } catch (e) {}
    var scope = box.closest('.shopify-section') || document;

    function selectedVariantId() {
      // Båda LP-köpblocken (svd-vs + v3-buy) markerar vald rad med
      // role=radio + aria-checked på element med data-variant-id.
      var sel = scope.querySelector('[data-variant-id][aria-checked="true"]');
      return sel ? parseInt(sel.getAttribute('data-variant-id'), 10) : 0;
    }

    function update() {
      var vid = selectedVariantId();
      if (!vid) { box.hidden = true; return; }
      box.hidden = main.indexOf(vid) === -1;
    }

    update();
    // Radval sker via klick/tangentbord — uppdatera efter att köpblockets
    // egna handlers hunnit flytta selekteringen.
    scope.addEventListener('click', function () { setTimeout(update, 0); });
    scope.addEventListener('keydown', function () { setTimeout(update, 0); });
  }

  function init() {
    document.querySelectorAll('[data-svd-lpo]').forEach(initBox);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
